import Image from "next/image"
import { COMPANY_LOGO_BLUE } from "@/lib/constants"

/**
 * FRIDGE-591 — the Fridge.com mark INSIDE every /data figure (owner,
 * 08/27/2026: "100% of data needs the Fridge.com logo within it. so if it
 * gets shared, then Fridge.com always gets shared").
 *
 * Renders in the figcaption strip of each chart figure, so any screenshot,
 * clip, or right-click-save of the artifact carries the brand — the mark is
 * part of the figure, not beside it. Same asset as the citation kit header
 * (COMPANY_LOGO_BLUE, the blue wordmark on light backgrounds).
 */
export function FigureBrandMark() {
  return (
    <span className="inline-flex items-center gap-1.5 shrink-0 select-none" aria-hidden="true">
      <Image
        src={COMPANY_LOGO_BLUE}
        alt=""
        width={78}
        height={16}
        className="h-4 w-auto opacity-90"
        // FRIDGE-1540: the class's 16 px and the file's aspect ratio (2215 x 391) inline,
        // so Chromium counts this lazy image as sized; the drawing is unchanged.
        style={{ height: 16, aspectRatio: '2215 / 391' }}
      />
    </span>
  )
}
